import request from '../utils/service';
const api = {
    getCarNum:function(data){
        return request({
            url:'/driver/v2/api/plateCount',
            method: 'get',
            params: data
        });
    },
    getPhone:function(data){
        return request({
            url:'/auth/v2/api/driver/loginInfo',
            method: 'get',
            params: data
        });
    },
    getPayType:function(data){
        return request({
            url:'/dealer/v2/api/parkPayTypesFetch',
            method: 'get',
            params: data
        });
    },
    getAmount:function(data){
        return request({
            url:'/driver/v2/api/balanceInfo',
            method: 'get',
            params: data
        });
    },
    getMenu:function(data){
        return request({
            url:'/basic/v2/api/menuConfigs',
            method: 'get',
            params: data
        });
    },
    getCoupponsNum:function(data){
        return request({
            url:'/coupon/v2/api/couponsCount',
            method: 'get',
            params: data
        });
    },
    getCouppons:function(data){
        return request({
            url:'/coupon/v2/api/sendPlateCoupon',
            method: 'post',
            data: data
        });
    },
    getCountUnfinished:function(data){
        return request({
            url:'/charge/v2/api/parkOrders/msp/countUnfinished',
            method: 'get',
            params: data
        });
    },
    // 获取token  huangxiangyang
    getToken: function(params){
        return request({
            url: `/driver/v2/api/getTokenByTicket?ticket=${params.ticket}&openid=${params.openid}`,
            method: 'get'
        });
    },
    // 获取车主组信息
    driverGroups: function(){
        return request({
            url: `/driver/v2/api/driverGroupMembers/getMineGroups`,
            method: 'get'
        });
    }
};

export default api;
